import { render, staticRenderFns } from "./StoreDashboardTemplate.vue?vue&type=template&id=b56c65e0&scoped=true"
import script from "./StoreDashboardTemplate.vue?vue&type=script&lang=js"
export * from "./StoreDashboardTemplate.vue?vue&type=script&lang=js"
import style0 from "./StoreDashboardTemplate.vue?vue&type=style&index=0&id=b56c65e0&prod&lang=css"
import style1 from "./StoreDashboardTemplate.vue?vue&type=style&index=1&id=b56c65e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56c65e0",
  null
  
)

export default component.exports